import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { VaLinkAction } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import { useHeadingLevels } from 'platform/forms-system/src/js/web-component-patterns/titlePattern';
import { hrefWithBasename } from './helpers';

// props are listed out rather than spread; withRouter also injects
// params/location/routes, which would land on the web component
const AddLinkBase = ({ to, router, text, onClick, name }) => (
  <VaLinkAction
    data-action="add"
    href={hrefWithBasename(router, to)}
    text={text}
    onClick={onClick}
    name={name}
    type="secondary"
  />
);

AddLinkBase.propTypes = {
  name: PropTypes.string,
  router: PropTypes.shape({
    createHref: PropTypes.func,
  }),
  text: PropTypes.node,
  to: PropTypes.string,
  onClick: PropTypes.func,
};

const AddLink = withRouter(AddLinkBase);

const ArrayBuilderSummaryReviewPage = ({
  customPageProps,
  arrayBuilderOptions,
  arrayData,
  addAnotherItemButtonClick,
  addAnotherItemPath,
  updatedItemData,
  alerts,
  cards,
  title,
  hideAdd,
}) => {
  const userHeaderLevel = arrayBuilderOptions.reviewPanelHeadingLevel;
  const { headingLevel } = useHeadingLevels({
    userHeaderLevel,
    isReviewPage: true,
  });
  const Header = `h${headingLevel}`;
  return (
    <>
      {arrayData?.length ? (
        title
      ) : (
        <>
          <div className="form-review-panel-page-header-row">
            <Header
              className="form-review-panel-page-header vads-u-font-size--h5"
              data-title-for-noun-singular={`${arrayBuilderOptions.nounSingular}`}
              data-array-path={arrayBuilderOptions.arrayPath}
            >
              {arrayBuilderOptions.getText(
                'summaryTitle',
                updatedItemData,
                customPageProps.data,
              )}
            </Header>
          </div>
          <dl className="review">
            <div className="review-row">
              <dt>
                {arrayBuilderOptions.getText(
                  'yesNoBlankReviewQuestion',
                  null,
                  customPageProps.data,
                )}
              </dt>
              <dd>
                <span
                  className="dd-privacy-hidden"
                  data-dd-action-name="data value"
                >
                  No
                </span>
              </dd>
            </div>
          </dl>
        </>
      )}
      {arrayBuilderOptions.getText(
        'summaryDescription',
        null,
        customPageProps.data,
      ) && (
        <span className="vads-u-font-family--sans vads-u-font-weight--normal vads-u-display--block">
          {arrayBuilderOptions.getText(
            'summaryDescription',
            null,
            customPageProps.data,
          )}
        </span>
      )}
      {alerts}
      {cards}
      {!hideAdd && (
        <div className="vads-u-margin-top--2">
          <AddLink
            to={addAnotherItemPath}
            text={arrayBuilderOptions.getText(
              'reviewAddButtonText',
              arrayData,
              customPageProps.data,
            )}
            onClick={e => {
              e.preventDefault();
              addAnotherItemButtonClick(customPageProps.chapterKey);
            }}
            name={`${arrayBuilderOptions.nounPlural}AddButton`}
          />
        </div>
      )}
    </>
  );
};

export default ArrayBuilderSummaryReviewPage;

ArrayBuilderSummaryReviewPage.propTypes = {
  addAnotherItemButtonClick: PropTypes.func,
  addAnotherItemPath: PropTypes.string,
  alerts: PropTypes.node,
  arrayBuilderOptions: PropTypes.object,
  arrayData: PropTypes.array,
  cards: PropTypes.node,
  customPageProps: PropTypes.shape({
    chapterKey: PropTypes.string,
    data: PropTypes.object,
  }),
  hideAdd: PropTypes.bool,
  title: PropTypes.node,
  updatedItemData: PropTypes.object,
};
